import Vue from 'vue'
import VolumeData from "./volume-data";

const store = {
    namespaced: true,

    state: {
        volumes: {}
    },

    mutations: {
        ADD_VOLUME: function (state, volumeData) {
            Vue.set(state.volumes, volumeData.branchID, volumeData);
        },

        REMOVE_MODEL: function (state, modelId) {
            for (let branchId in state.volumes) {
                if (state.volumes.hasOwnProperty(branchId)) {
                    if (state.volumes[branchId].modelId === modelId) {
                        Vue.delete(state.volumes, branchId);
                    }
                }
            }
        },
        
        SET_HIGHLIGHT: function (state, {branchId, isHighlighted}) {
            state.volumes[branchId]?.setHighlight(isHighlighted);
        },

        SET_VISIBILITY: function (state, {branchId, isVisible}) {
            VR.scene.dispatchEvent({ type: "volumeVisibility", meshName: branchId, visible: isVisible});
        },
        
        SET_TRANSPARENCY: function (state, {branchId, isTransparent, animationDuration}) {
            state.volumes[branchId]?.setTransparency(isTransparent, animationDuration);
        }
    },

    actions: {
        addModel: function ({commit}, modelId) {
            const volumes = modelManager.getVolumesByModelId(modelId);
            for (const volume of volumes) {
                commit('ADD_VOLUME', new VolumeData({
                    modelId,
                    branchId : volume.branchID,
                }));
            }
        },

        removeModel: function ({commit}, modelId) {
            commit('REMOVE_MODEL', modelId);
        }
    }
};

export function register(rootStore) {
    rootStore.registerModule('volume_store', store);

    wv.rootObject.addEventListener(ModelEvents.LOAD, event => {
        rootStore.dispatch('volume_store/addModel', event.modelId);
    });

    wv.rootObject.addEventListener(ModelEvents.UNLOAD, event => {
        rootStore.dispatch('volume_store/removeModel', event.modelId);
    });
}
